"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ALL_TERMINAL_NODES_FOR_STRATEGY_MATRIX = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_ALL_TERMINAL_NODES_FOR_STRATEGY_MATRIX = (0, gql_1.gql)(`
 query GetAllTerminalNodes($productTreeNodeId: ID!, $filter: ProductTreeNodeDescendantFilter, $first: Int) {
  productTreeNode(id: $productTreeNodeId) {
    id
    descendants(filter: $filter, first: $first) {
      totalCount
      edges {
        node {
          descendant {
            id
            title
          }
        }
      }
    }
  }
}
`);
